// 获取小时差，剩余时间全部向上取整
export default function getHoursDiffFromNow(time: number) {
  const now: Date = new Date();
  const inputTime: Date = new Date(time);

  const diffMs = +inputTime - +now; // 毫秒差
  const diffHours = Math.ceil(diffMs / (1000 * 60 * 60)); // 转换成小时并向上取整

  return diffHours > 0 ? diffHours : 0;
}

// 获取小时差，大于1小时，向下取整，否则向上取整
export function getHoursDiffFromNowNew(time: number) {
  const now: Date = new Date();
  const inputTime: Date = new Date(time);

  const diffMs = +inputTime - +now; // 毫秒差
  const hoursDiffNum = diffMs / (1000 * 60 * 60);
  const diffHours =
    hoursDiffNum > 1 ? Math.floor(hoursDiffNum) : Math.ceil(hoursDiffNum); // 大于1小时，向下取整，否则向上取整

  return diffHours > 0 ? diffHours : 0;
}
